import React from 'react';
//components
import { Visibility } from 'components/Visibility';
//interfaces
import { ToogleProps } from './interface';
//context
import { useTabsContext } from 'contexts/Tabs';
//styles
import { ToggleContent, SwitchInput, SwitchLabel, SwitchButton, TextLabel, Loader } from './styles';

export const Toggle: React.FC<ToogleProps> = (props) => {
  const { disableTabs } = useTabsContext();
  const { id, toggled, onChange, label, disabled, isLine } = props;

  return (
    <ToggleContent>
      <SwitchInput
        id={id}
        data-testid={id}
        checked={toggled}
        onChange={onChange}
        disabled={disabled ?? false}
      />
      <SwitchLabel
        htmlFor={id}
        isLine={isLine}
        toggled={toggled}
        className="switch-label"
        disableTabs={disableTabs}
      >
        <Visibility visible={disabled ?? false}>
          <Loader />
        </Visibility>

        <TextLabel isLine={isLine} toggled={toggled}>{label}</TextLabel>
        <SwitchButton
          isLine={isLine}
          toggled={toggled}
          className="switch-button"
        />
      </SwitchLabel>
    </ToggleContent>
  );
};